import * as React from "react";
import { EMAIL_SUFFIX } from "Source/components/project/Config/Config";
import { checkWorkstreamEmail } from "Source/reducers/workstream/workstream.service";
import { maxLengthRule, validCFOEmailRule, validEmailInputRule, createValidationRule } from "Source/util/form/form.rules";

export const confirmationModal = {
  title: 'Confirm Workstream Creation',
  default: {
    body: email => <React.Fragment>
      <p>You are about to create a workstream with assigned email below:</p>
      <p class="account-email">{`${email}`}</p>
      <p>Please ensure this is correct. Workstream emails can no longer be edited upon confirmation.</p>
    </React.Fragment>
  },
  fromTemplate: {
    body: email => <React.Fragment>
      <p>You are about to create a workstream with assigned email:</p>
      <p class="account-email">{`${email}`}</p>
      <p>Please ensure this is correct. Email can no longer be edited once confirmed.</p>
    </React.Fragment>
  }
}

export function emailExistsRule({ accountNameSuffix, message, workstreamId }) {
  return createValidationRule(
    "emailExists",
    message,
    async (inputValue, inputObj) => {
      const currentEmail = `${inputObj.email.defaultValue}-${accountNameSuffix}`;
      const inputEmail = `${inputValue}-${accountNameSuffix}`;

      if (currentEmail === inputEmail) {
        return true;
      }

      return await checkWorkstreamEmail({ email: inputEmail, workstreamId });
    }
  );
}

export const saveWorkstreamForm = ({ accountNameSuffix, workstreamId }) => ({
  email: {
    validationRules: [
      maxLengthRule("email", 300),
      validEmailInputRule("email"),
      validCFOEmailRule("email"),
      emailExistsRule({
        accountNameSuffix, 
        message: 'Email already assigned to another account!',
        workstreamId,
      }),
    ],
  },
});

